import { observer } from 'mobx-react-lite';
import getContextMenus from '../../utils/ContextMenu/getContextMenus';
import { DirectionalHint } from 'office-ui-fabric-react/lib/common/DirectionalHint';
import { ContextualMenu } from 'office-ui-fabric-react/lib/ContextualMenu';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import setAttachmentShouldShowContextMenu from 'owa-attachment-full-data/lib/actions/setAttachmentShouldShowContextMenu';
import { AttachmentModel } from 'owa-attachment-model-store';
import { PreviewContext } from 'owa-attachment-select-actions';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';
import isSxSDisplayed from 'owa-sxs-store/lib/utils/isSxSDisplayed';
import * as React from 'react';

export interface AttachmentContextMenuProps {
    attachment: AttachmentModel;
    attachmentViewState: AttachmentFullViewState;
    targetElementGetter: () => HTMLElement;
    previewContext: PreviewContext;
    parentItemId: ItemId;
    onReplaceAttachment: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void;
    moveAttachmentToInlineHandler?: (
        attachment: AttachmentFullViewState,
        contentId: string
    ) => void;
    referenceAttachmentsSupported?: () => boolean;
    isSxS?: boolean;
}

// This component is responsible for showing the attachment context menu view.
export default observer(function AttachmentContextMenuView(props: AttachmentContextMenuProps) {
    const onDismissContextMenu = (ev: any) => {
        setAttachmentShouldShowContextMenu(props.attachmentViewState, false);
    };
    const shouldShowBasedOnSxS = props.isSxS || !isSxSDisplayed();
    if (shouldShowBasedOnSxS && props.attachmentViewState.shouldShowContextMenu) {
        return (
            <ContextualMenu
                shouldFocusOnMount={true}
                directionalHint={DirectionalHint.bottomRightEdge}
                target={props.targetElementGetter()}
                onDismiss={onDismissContextMenu}
                items={getContextMenus(
                    props.attachmentViewState,
                    props.attachment,
                    props.previewContext,
                    props.parentItemId,
                    props.onReplaceAttachment,
                    null /* container */,
                    props.moveAttachmentToInlineHandler,
                    props.referenceAttachmentsSupported
                )}
            />
        );
    } else {
        return null;
    }
});
